/* Oddit "Do First" PDP additions (preview theme).
   The product form is a Vue root, so everything here uses event delegation
   and looks elements up lazily instead of binding to nodes at load. */
(function () {
  'use strict';

  var REVIEW_TARGETS = [
    '#reviews', '#judgeme_product_reviews', '.jdgm-review-widget', '[data-oke-widget]',
    '.okeReviews', '#shopify-product-reviews', '.junip-product-review-widget',
    '.yotpo-main-widget', '#stamped-main-widget', '#looxReviews',
    '.klaviyo-reviews', '[id^="klaviyo-reviews"]', '[data-reviews-widget]'
  ];

  function headerOffset() {
    var h = document.querySelector('.header-bar-wrapper');
    return (h ? h.getBoundingClientRect().height : 0) + 12;
  }

  function scrollToEl(el) {
    if (!el) return;
    var y = el.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    var target = Math.max(0, Math.round(y));
    var maxY = document.documentElement.scrollHeight - window.innerHeight;
    target = Math.min(target, Math.max(0, maxY));
    window.scrollTo({ top: target, behavior: 'smooth' });
    // Fallback: if smooth scrolling stalled (e.g. background tab), finish the jump.
    setTimeout(function () {
      if (Math.abs(window.pageYOffset - target) > 40) window.scrollTo(0, target);
    }, 900);
  }

  /* ---------- Size guide: reuse the existing "Size and Fit" accordion (KiwiSizing chart) ---------- */
  function findSizeAccordionTitle() {
    var dts = document.querySelectorAll('.product__details .accordion dt.accordion__title');
    for (var i = 0; i < dts.length; i++) {
      if (/size/i.test(dts[i].textContent || '')) return dts[i];
    }
    return null;
  }

  function openSizeGuide() {
    var dt = findSizeAccordionTitle();
    if (!dt) return;
    var dd = dt.nextElementSibling;
    var isOpen = dt.classList.contains('opened') || dt.classList.contains('active') || dt.classList.contains('is-active') ||
      dt.classList.contains('open') || (dd && dd.offsetHeight > 2 && getComputedStyle(dd).display !== 'none');
    if (!isOpen) {
      var btn = dt.querySelector('button') || dt;
      btn.click();
    }
    setTimeout(function () { scrollToEl(dt); }, 60);
  }

  /* ---------- Reviews link ---------- */
  function findReviews() {
    for (var i = 0; i < REVIEW_TARGETS.length; i++) {
      var el = document.querySelector(REVIEW_TARGETS[i]);
      if (el && !el.closest('.oddit-pdp-rating')) return el;
    }
    return null;
  }

  /* ---------- Gallery thumbnails ---------- */
  function slider() {
    var el = document.getElementById('product__slider');
    return el && el.swiper && !el.swiper.destroyed ? el.swiper : null;
  }

  function galleryImages() {
    // Original (non-duplicate) product images, in Liquid order.
    return Array.prototype.filter.call(
      document.querySelectorAll('.product__row .product__images-wrapper > .product__image--others'),
      function (n) { return !n.classList.contains('swiper-slide-duplicate'); }
    );
  }

  function setActive(index) {
    var btns = document.querySelectorAll('.oddit-pdp-thumbs__btn');
    for (var i = 0; i < btns.length; i++) {
      var on = parseInt(btns[i].getAttribute('data-index'), 10) === index;
      btns[i].classList.toggle('is-active', on);
      if (on) btns[i].setAttribute('aria-current', 'true'); else btns[i].removeAttribute('aria-current');
    }
    var row = document.querySelector('.oddit-pdp-thumbs--row');
    var act = row && row.querySelector('.oddit-pdp-thumbs__btn.is-active');
    if (row && act) {
      var left = act.offsetLeft - (row.clientWidth - act.offsetWidth) / 2;
      row.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
    }
  }

  var boundSwiper = null;
  function bindSwiper() {
    var sw = slider();
    if (!sw || sw === boundSwiper) return;
    boundSwiper = sw;
    sw.on('slideChange', function () { setActive(sw.realIndex || 0); });
    setActive(sw.realIndex || 0);
  }

  function goTo(index) {
    var sw = slider();
    if (sw) {
      if (typeof sw.slideToLoop === 'function') sw.slideToLoop(index); else sw.slideTo(index);
      setActive(index);
      return;
    }
    var imgs = galleryImages();
    if (imgs[index]) {
      scrollToEl(imgs[index]);
      setActive(index);
    }
  }

  var observer = null;
  function observeGrid() {
    if (observer || !('IntersectionObserver' in window)) return;
    var imgs = galleryImages();
    if (imgs.length < 2) return;
    observer = new IntersectionObserver(function (entries) {
      if (slider()) return;
      var best = null;
      entries.forEach(function (e) {
        if (e.isIntersecting && (!best || e.intersectionRatio > best.intersectionRatio)) best = e;
      });
      if (best) setActive(imgs.indexOf(best.target));
    }, { rootMargin: '-35% 0px -45% 0px', threshold: [0, 0.25, 0.5] });
    imgs.forEach(function (n) { observer.observe(n); });
  }

  /* ---------- Sibling-product switches replace the history entry ----------
     Sole pills, the "Same upper, two soles" cards and the "Select Color" swatches link to
     sibling products. Switching between them should not stack history entries, so Back
     returns to the page the shopper came from (collection, home, etc.). Modifier / middle
     clicks and new-tab targets are left to the browser. */
  var SIBLING_LINKS = 'a.oddit-pdp-sole__option[href], a.oddit-sx__card--link[href], .product__variant--color a.color-swatch__select-button[href]';

  function isPlainLeftClick(e) {
    return e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest || e.defaultPrevented || !isPlainLeftClick(e)) return;
    var a = t.closest(SIBLING_LINKS);
    if (!a) return;
    var target = (a.getAttribute('target') || '').toLowerCase();
    if (target && target !== '_self') return;
    var url;
    try { url = new URL(a.getAttribute('href'), window.location.href); } catch (err) { return; }
    if (url.origin !== window.location.origin || url.pathname.indexOf('/products/') === -1) return;
    if (url.pathname === window.location.pathname && !url.search && !url.hash) { e.preventDefault(); return; }
    e.preventDefault();
    window.location.replace(url.href);
  });

  /* ---------- Delegated clicks ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var sg = t.closest('[data-oddit-sizeguide]');
    if (sg) { e.preventDefault(); openSizeGuide(); return; }

    var rv = t.closest('[data-oddit-reviews-link]');
    if (rv) {
      var target = findReviews();
      if (target) { e.preventDefault(); scrollToEl(target); }
      return;
    }

    var th = t.closest('.oddit-pdp-thumbs__btn');
    if (th) {
      e.preventDefault();
      goTo(parseInt(th.getAttribute('data-index'), 10) || 0);
    }
  });

  function init() {
    if (findSizeAccordionTitle()) document.body.classList.add('oddit-has-sizeguide');
    bindSwiper();
    observeGrid();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', function () { init(); setTimeout(bindSwiper, 300); });
  var rt = null;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(function () { boundSwiper = null; bindSwiper(); }, 350);
  });
})();
